import { UpdateCampaignData } from '@src/types/campaign';
import { AssignInfluencerData, InfluencerToSend } from '@src/types/influencer';
import { GetCampaignListParams } from './index.d';
import { oliveApi } from '..';

const url = '/admin/v1/campaigns';

export const getCampaignListApi = async (params?: GetCampaignListParams) => {
  return await oliveApi.GET<GetCampaignListParams, any>(`${url}`, params);
};

export const getCampaignByIdApi = async (campaignId: string | number) => {
  return await oliveApi.GET<null, any>(`${url}/${campaignId}`);
};

export const updateCampaignByIdApi = async (updateData: UpdateCampaignData) => {
  return await oliveApi.PATCH<UpdateCampaignData, any>(
    `${url}/${updateData.id}`,
    updateData
  );
};

export const assignInfluencerToCampaignApi = async ({
  id,
  data,
}: AssignInfluencerData) => {
  return await oliveApi.POST<{ influencers: InfluencerToSend[] }, any>(
    `${url}/${id}/influencers`,
    { influencers: data }
  );
};
